import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMinLengthValidationMessageResolver implements ValidationMessageResolver<{ requiredLength: unknown }> {
  private readonly translate = inject(TranslateService);
  readonly errorCode = 'minlength';

  getMessage(error?: { requiredLength: unknown }): string {
    return this.translate.instant('label.validation.minLength.value', { value: error?.requiredLength });
  }
}
